import React from 'react';
import TextField from '@mui/material/TextField';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface PercentageFieldProps
  extends Omit<
    NumericFormatProps,
    'value' | 'onValueChange' | 'customInput' | 'onChange' | 'size' | 'color'
  > {
  value: number | null;
  onChange?: (value: number | null) => void;
  label?: string;
  helperText?: string;
  allowDecimalScale?: boolean;
  error?: boolean;
}

export const PercentageField: React.FC<PercentageFieldProps> = ({
  value,
  onChange,
  label,
  helperText,
  allowDecimalScale = true,
  ...rest
}) => {
  return (
    <NumericFormat
      value={value != null ? value * 100 : ''}
      decimalScale={allowDecimalScale ? 2 : 0}
      fixedDecimalScale
      allowNegative={false}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={''}
      suffix={' %'}
      customInput={TextField}
      label={label}
      helperText={helperText}
      fullWidth
      onValueChange={({ floatValue }) => {
        onChange?.(floatValue != null ? floatValue / 100 : null);
      }}
      {...rest}
    />
  );
};

export default PercentageField;
